import { Icon, Text, Tooltip, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';
import { Pressable } from 'react-native';

import { HighlightableText } from '../HighlightableText';
import { ItemDate } from '../ItemDate';

import { TradingListItemTypes } from '.';

export const TradingListItemTablet: React.FC<TradingListItemTypes.Content> = ({
  item,
  purchaseQtyChanged,
  saleQtyChanged,
  operationChanged,
  positionChanged,
  lastUpdatedAt,
}) => {
  const [openAccordion, setOpenAccordion] = React.useState('closed');
  const handlePress = () => {
    setOpenAccordion(openAccordion === 'closed' ? 'opened' : 'closed');
  };
  return (
    <VStack
      borderTopWidth={1}
      borderTopColor={Color['neutral.lightest']}
      marginBottom={Spacing['inset.sm']}>
      <HStack
        width="100%"
        justifyContent="space-between"
        marginX={Spacing['inset.xs']}
        paddingY={Spacing['inset.quarck']}>
        <VStack px={Spacing['inline.nano']} py={Spacing['inset.xs']}>
          <Text
            paddingBottom={Spacing['inline.quarck']}
            fontSize={Typography['fontsize.md']}
            fontWeight={Typography['fontweight.semibold']}>
            Papel
          </Text>
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            fontSize={Typography['fontsize.md']}
            textAlign="start">
            {item.paper}
          </Text>
        </VStack>

        <VStack px={Spacing['inline.nano']} py={Spacing['inset.xs']}>
          <Text
            paddingBottom={Spacing['inline.quarck']}
            fontSize={Typography['fontsize.md']}
            fontWeight={Typography['fontweight.semibold']}>
            Data
          </Text>
          <ItemDate updatedAtDto={item.date} updatedAtDynamic={lastUpdatedAt} />
        </VStack>

        <VStack px={Spacing['inline.nano']} py={Spacing['inset.xs']}>
          <Text
            paddingBottom={Spacing['inline.quarck']}
            fontSize={Typography['fontsize.md']}
            fontWeight={Typography['fontweight.semibold']}>
            Qtd.Venda
          </Text>
          <HighlightableText shouldHighlight={saleQtyChanged}>{item.saleQty}</HighlightableText>
        </VStack>

        <VStack px={Spacing['inline.nano']} py={Spacing['inset.xs']}>
          <Text
            paddingBottom={Spacing['inline.quarck']}
            fontSize={Typography['fontsize.md']}
            fontWeight={Typography['fontweight.semibold']}>
            Qtd.Compra
          </Text>
          <HighlightableText shouldHighlight={purchaseQtyChanged}>
            {item.purchaseQty}
          </HighlightableText>
        </VStack>

        <VStack px={Spacing['inline.nano']} py={Spacing['inset.xs']}>
          <Tooltip
            flex={1}
            alignItems="center"
            label={
              'Entenda a posição.\n0 - Não há posição em aberto\n1 > Quantidade restante comprado\n0 < Quantidade restante vendido'
            }
            testID="tooltipe-header">
            <Box>
              <HStack minWidth="100%" alignItems="center" flex={1}>
                <Icon name="Info" color={Color['neutral.dark']} size="xxxs" testId="status-icon" />
                <Text
                  paddingLeft={Spacing['inline.quarck']}
                  fontSize={Typography['fontsize.md']}
                  fontWeight={Typography['fontweight.semibold']}>
                  Posição
                </Text>
              </HStack>
              <HighlightableText shouldHighlight={positionChanged}>
                {item.position}
              </HighlightableText>
            </Box>
          </Tooltip>
        </VStack>

        <VStack
          justifyItems="flex-end"
          px={Spacing['inline.nano']}
          py={Spacing['inset.xs']}
          width="20%">
          <Box>
            <Text
              paddingBottom={Spacing['inline.quarck']}
              fontSize={Typography['fontsize.md']}
              fontWeight={Typography['fontweight.semibold']}>
              Operação
            </Text>
            <Pressable onPress={handlePress}>
              <HStack alignItems="center" maxWidth="60%" flexDir="row">
                <HighlightableText shouldHighlight={operationChanged}>
                  {item.operation}
                </HighlightableText>
                <Icon
                  testID="action-icon"
                  name={openAccordion === 'opened' ? 'ChevronUp' : 'ChevronDown'}
                  size="xxs"
                  color={Color['brand.primary.dark']}
                />
              </HStack>
            </Pressable>
          </Box>
        </VStack>
      </HStack>

      {openAccordion === 'opened' && (
        <>
          {item?.tradings?.map((itemTrading, index) => (
            <HStack
              width="100%"
              key={`${index}`}
              borderRadius="sm"
              paddingX={Spacing['inset.xs']}
              marginX={Spacing['inset.sm']}
              backgroundColor={Color.background}
              justifyContent="space-between"
              paddingY={Spacing['inset.nano']}>
              <VStack width="20%" px={Spacing['inline.nano']} py={Spacing['inset.xs']}>
                <Text
                  numberOfLines={1}
                  ellipsizeMode="tail"
                  fontWeight={Typography['fontweight.semibold']}
                  fontSize={Typography['fontsize.md']}
                  textAlign="start"
                  paddingBottom={Spacing['inset.quarck']}>
                  Operação
                </Text>
                <Text
                  numberOfLines={1}
                  ellipsizeMode="tail"
                  fontWeight={Typography['fontweight.regular']}
                  fontSize={Typography['fontsize.md']}
                  textAlign="start">
                  {itemTrading.operation}
                </Text>
              </VStack>

              <VStack width="20%" px={Spacing['inline.nano']} py={Spacing['inset.xs']}>
                <Text
                  numberOfLines={1}
                  ellipsizeMode="tail"
                  fontWeight={Typography['fontweight.semibold']}
                  fontSize={Typography['fontsize.md']}
                  textAlign="start"
                  paddingBottom={Spacing['inset.quarck']}>
                  Qtd. executadas
                </Text>
                <Text
                  numberOfLines={1}
                  ellipsizeMode="tail"
                  fontWeight={Typography['fontweight.regular']}
                  fontSize={Typography['fontsize.md']}
                  textAlign="start">
                  {itemTrading.executedQty}
                </Text>
              </VStack>

              <VStack width="20%" px={Spacing['inline.nano']} py={Spacing['inset.xs']}>
                <Text
                  numberOfLines={1}
                  ellipsizeMode="tail"
                  fontWeight={Typography['fontweight.semibold']}
                  fontSize={Typography['fontsize.md']}
                  textAlign="start"
                  paddingBottom={Spacing['inset.quarck']}>
                  Preço executado
                </Text>
                <Text
                  numberOfLines={1}
                  ellipsizeMode="tail"
                  fontWeight={Typography['fontweight.regular']}
                  fontSize={Typography['fontsize.md']}
                  textAlign="start">
                  {itemTrading.executedPrice}
                </Text>
              </VStack>

              <VStack width="20%" px={Spacing['inline.nano']} py={Spacing['inset.xs']}>
                <Text
                  numberOfLines={1}
                  ellipsizeMode="tail"
                  fontWeight={Typography['fontweight.semibold']}
                  fontSize={Typography['fontsize.md']}
                  textAlign="start"
                  paddingBottom={Spacing['inset.quarck']}>
                  Mercado
                </Text>
                <Text
                  numberOfLines={1}
                  ellipsizeMode="tail"
                  fontWeight={Typography['fontweight.regular']}
                  fontSize={Typography['fontsize.md']}
                  textAlign="start">
                  {itemTrading.market}
                </Text>
              </VStack>

              <VStack
                justifyItems="flex-end"
                width="20%"
                px={Spacing['inline.nano']}
                py={Spacing['inset.xs']}>
                <Box>
                  <Text
                    numberOfLines={1}
                    ellipsizeMode="tail"
                    fontWeight={Typography['fontweight.semibold']}
                    fontSize={Typography['fontsize.md']}
                    textAlign="start"
                    paddingBottom={Spacing['inset.quarck']}>
                    Status
                  </Text>
                  <Text
                    numberOfLines={1}
                    ellipsizeMode="tail"
                    fontWeight={Typography['fontweight.regular']}
                    fontSize={Typography['fontsize.md']}
                    textAlign="start">
                    {itemTrading.status}
                  </Text>
                </Box>
              </VStack>
            </HStack>
          ))}
        </>
      )}
    </VStack>
  );
};
